import React, { useEffect, useState, useRef } from 'react';
import blue_drop_down from '../../../assets/images/blue_dropdown_arrow.png'
import klogoGreen from '../../../assets/images/LogoKDarkGreen.png'
import PrimaryCard from '../../../assets/smi-kudzu-images/smi_card_img.png'
import { useTranslation } from 'react-i18next';
import { useKeyDown } from '../../../hooks/useKeyDown';
import { useSelector } from 'react-redux';
import { selectIsTransferMoneyFeatureEnabled } from '../../../Redux/selectors';
import { displayErrorMessage, displayKudzuplusErrorMessage } from '../../../utils';
import logFirebaseEvents from '../../LogFirebaseEvents';
import { appTheme } from '../../../helpers/utils/Utils';
import { resolveAccountLogo } from '../../../helpers/utils/TransferMoneyUtils';

const CustomDropdown = (props) => {
    const { t } = useTranslation(); // Hook to access translation functions
    const [isOpen, setIsOpen] = useState(false);
    const [isInternalAccount, setIsInternalAccount] = useState(false)
    const [accountBalance, setAccountBalance] = useState(0);
    const [disabled, setDisabled] = useState(props?.disabled || 'not_disabled');
    const [showDropDown, setShowDropDown] = useState((props.showDropDown === undefined || props.showDropDown === null) ? true : props.showDropDown);
    const [selectedIndex, setSelectedIndex] = useState(null)
    const dropdownRef = useRef(); // Ref to the dropdown list 
    const cards = useSelector(state => JSON.parse(state.userCards));
    const kudzuPlusTrue = useSelector(state => state.kudzuPlusTrue);
    const appThemeData = appTheme(kudzuPlusTrue)
    const isTransferMoneyFeatureEnabled = useSelector(selectIsTransferMoneyFeatureEnabled);

    const check = () => {
        if (props?.selectedAccountType?.ACHAccountInternalId === 0) {
            const internalAccount = cards.find((card) => card.CardKey === props?.selectedAccountType?.AccountId)
            setAccountBalance(internalAccount?.Balance.toFixed(2))
            setIsInternalAccount(true);
        } else {
            setAccountBalance(0)
            setIsInternalAccount(false);

        }
    }


    useEffect(() => {
        check();
    }, [props?.onSelect])

    useEffect(() => {
        if (isOpen && selectedIndex !== null && selectedIndex !== -1) {
            const selectedItem = dropdownRef.current.querySelector(`[data-index="${selectedIndex}"]`);
            if (selectedItem) {
                selectedItem.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
            }
        }
    }, [selectedIndex, isOpen]);

    useEffect(() => { if (isOpen) { dropdownRef.current.focus() } }, [dropdownRef])




    const toggleDropdown = () => {
        setIsOpen(!isOpen);
    };

    const handleOptionSelect = (option, index) => {
        logFirebaseEvents("Contact_Us", "Select_Type_Clicked", "Select_Type_Clicked","", "")
        setSelectedIndex(index);
        props?.onSelect?.(option);
        setIsOpen(false);
    };

    const handleActionClick = () => {
        props?.onActionClick?.();
        setIsOpen(false);
    }

    const getAccountLogo = (account) =>
        resolveAccountLogo(account, { klogoGreen, primaryCard: PrimaryCard, fallback: appThemeData.FPO });

    const getOptionBalance = (option) => {
        if (!option || option?.ACHAccountInternalId !== 0) return null;
        const internalAccount = cards?.find((card) => card.CardKey === option?.AccountId);
        const balance = internalAccount?.Balance;
        if (typeof balance !== 'number' || Number.isNaN(balance)) return null;
        return balance;
    };
    // useKeyDown(() => {
    //     handleOptionSelect(props?.options?.[1],0);//need to check index
    // }, ["Enter"]);


    const handleKeyDown = (event) => {
        const isChrome = /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor) && !/Edg|Firefox|Safari|OPR|MSIE|Trident/.test(navigator.userAgent);
        if (!isChrome) {
            if (event.key === 'ArrowDown') {
                event.preventDefault();
                setSelectedIndex((prevIndex) =>
                    prevIndex < props.options.length - 1 ? prevIndex + 1 : prevIndex
                );
            } else if (event.key === 'ArrowUp') {
                event.preventDefault();
                setSelectedIndex((prevIndex) => (prevIndex > 0 ? prevIndex - 1 : prevIndex));
            }
            else if (event.key === 'Tab') {
                if (event.shiftKey) {
                    if (selectedIndex > 0) {
                        event.preventDefault();
                        setSelectedIndex((prevIndex) => (prevIndex > 0 ? prevIndex - 1 : prevIndex));
                    }
                } else if (selectedIndex < props.options.length - 1) {
                    event.preventDefault();
                    setSelectedIndex((prevIndex) => prevIndex < props.options.length - 1 ? prevIndex + 1 : prevIndex);
                }
            }

            if (event.key === 'Enter') {
                //     if (selectedIndex !== -1) {
                event.preventDefault();
                handleOptionSelect(props.options[selectedIndex], selectedIndex);
            }
        }
    };
    // useEffect(() => {
    //     if (selectedIndex !== -1) {
    //       const list = dropdownRef.current;
    //       const selectedItem = list.querySelector(`[data-index="${selectedIndex}"]`);
    //       if (selectedItem) {
    //         const yOffset = selectedItem.getBoundingClientRect().top - list.getBoundingClientRect().top;
    //         list.scrollTo({ top: yOffset, behavior: 'smooth' });
    //       }
    //     }
    //   }, [selectedIndex]);



    return (
        <>
{isTransferMoneyFeatureEnabled ? (
                <div className=' flex flex-col w-full'>
                    <p className='font-hanken-grotesk text-[var(--input-text-title)] 
      uppercase text-[13px] sm:text-[9px] md:text-[12px] lg:text-[13px]
       font-[600] tracking-[2px] pb-2'>{props?.title?.toLocaleUpperCase() || ''}{props?.required && <span className='text-[12px] text-[#FF7468]'>*</span>}</p>

                    <div className={`w-full ${props?.boxed ? `${kudzuPlusTrue ? 'bg-[#324261] rounded-[2px] sm:px-4 px-3 sm:py-4 py-3' : `border-[2px] ${isOpen ? 'border-[#2965FB]' : 'border-[var(--input-border)]'} rounded-[2px] sm:px-4 px-3 sm:py-4 py-3`}` : ''} ${isOpen && 'outline-none'}`} onClick={() => { if (props?.disabled) { if (props.disabled === 'not_disabled') { toggleDropdown(); } } else { toggleDropdown(); } }}
                        tabIndex={0}
                        onKeyDown={(event) => {
                            const isChrome = /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor) && !/Edg|Firefox|Safari|OPR|MSIE|Trident/.test(navigator.userAgent);
                            if (event.key === "Enter") {
                                event.preventDefault();
                                if (props?.disabled) { if (props.disabled === 'not_disabled') { toggleDropdown(); } } else { toggleDropdown(); }
                                if ((selectedIndex > '-1') && (selectedIndex !== null) && (!isChrome) && (isOpen)) { handleOptionSelect(props.options[selectedIndex], selectedIndex); }
                            } else if (!isChrome && event.key === 'ArrowDown') {
                                if (isOpen) { event.preventDefault(); }
                                setSelectedIndex((prevIndex) => (prevIndex > '-1' && prevIndex !== null && prevIndex !== undefined) ? prevIndex < props.options.length - 1 ? (prevIndex > '-1' && prevIndex !== null) ? (prevIndex + 1) : 0 : prevIndex : 0);
                            } else if (!isChrome && event.key === 'ArrowUp') {
                                if (isOpen) { event.preventDefault(); }
                                setSelectedIndex((prevIndex) => (prevIndex > 0 ? prevIndex - 1 : prevIndex));
                            }
                            else if ((!isChrome) && (event.key === 'Tab') && isOpen) {

                                if (event.shiftKey) {
                                    if (selectedIndex > 0) {
                                        event.preventDefault();
                                        setSelectedIndex((prevIndex) => (prevIndex > 0 ? prevIndex - 1 : prevIndex));
                                    } else if (selectedIndex === 0) { toggleDropdown(); setSelectedIndex('-1') }
                                } else if (selectedIndex < props.options.length - 1 || Number(selectedIndex) === -1 || selectedIndex === null || selectedIndex === undefined) {
                                    event.preventDefault();
                                    setSelectedIndex((prevIndex) => (prevIndex > '-1' && prevIndex !== null && prevIndex !== undefined) ? prevIndex < props.options.length - 1 ? (prevIndex > '-1' && prevIndex !== null) ? (prevIndex + 1) : 0 : prevIndex : 0);
                                } else if (selectedIndex >= props.options.length - 1) {
                                    event.preventDefault();
                                }
                            }
                        }
                        }
                    >
                        <div className={`flex justify-between flex-row w-full items-center ${isOpen && 'outline-none'}`}>
                            <div className={`flex flex-row items-center gap-3 w-full ${isOpen && 'outline-none'}`}>
                                {props?.boxed && (props?.selectedAccountType?.Name || props?.selectedAccountType?.AccountName || props?.selectedAccountType?.DisplayText) &&
                                    <img src={getAccountLogo(props?.selectedAccountType)} alt="" className='w-4 h-4 object-contain shrink-0' />
                                }
                                <div className='flex sm:flex-row flex-col sm:items-center justify-between w-full sm:gap-2'>
                                    <p contentEditable={false} className={`font-[500] text-[var(--input-text-value)] font-hanken-grotesk lg:text-[16px]
 md:text-[15px] sm:text-[13px] text-[14px] cursor-none ${isOpen && 'outline-none'}`}>
                                        {props?.selectedAccountType?.Name || props?.selectedAccountType?.AccountName?.slice(0, -6) || props?.selectedAccountType?.DisplayText || props?.selectedFrequency || (props?.boxed ? t('select_an_account') : t('select'))}
                                        <span className="font-[700] font-hanken-grotesk 
 md:text-[12px] sm:text-[9px] text-[12px]">{props?.selectedAccountType?.AccountName?.slice(-6)}</span>
                                    </p>
                                    {isInternalAccount && (
    <p
        className={`${props?.boxed ? 'text-[#2C815D]' : 'text-[var(--text-clr-transactions)]'} mt-2 sm:mt-0 font-hanken-grotesk font-[600] text-[16px] leading-[24px] md:leading-[26px] sm:text-[12px] md:text-[14px] sm:text-right whitespace-nowrap cursor-none ${isOpen ? 'outline-none' : ''}`}
    >
        {t('amount_available', { amount: accountBalance })}
    </p>
                                    )}
                                </div>
                            </div>
                            <div className='shrink-0'>
                                {!props?.hideArrow &&
                                    <img
                                        src={appThemeData.dropDownIcon}
                                        alt="dropdown-icon"
                                        className={`w-4 h-4 ${props?.boxed ? 'ml-4' : 'ml-10'} cursor-pointer outline-none}`}
                                    />

                                }

                            </div>
                        </div>

                        {!props?.boxed &&
                            <hr tabindex="-2" className={` h-[2px] ${props?.hrbg ? props?.hrbg : 'bg-[var(--content-border)] opacity-[50%]'} border-0 rounded`} />
                        }
                    </div>
                    {isOpen && (
                        <div className={`bg-[var(--custom-dropdown-bg)] shadow-lg relative z-10 ${props?.isScroll ? 'max-h-[13rem] overflow-y-auto' : 'sm:max-h-[30rem] max-h-[20rem] overflow-y-auto'}`}>
                            <ul
                                onBlur={() => setSelectedIndex(-1)} // Reset selection when the dropdown loses focus
                                onKeyDown={handleKeyDown}
                                ref={dropdownRef

                                }>
                                {props?.options?.map((option, index) => {
                                    const selectedAcc = props?.selectedAccountType;
                                    const isSelectedOption = props?.boxed && option?.Name !== t('no_linked_acccounts') && selectedAcc && (
                                        (option?.AccountId !== undefined && option?.AccountId !== null && option.AccountId === selectedAcc?.AccountId) ||
                                        (option?.AccountName !== undefined && option?.AccountName !== null && option.AccountName === selectedAcc?.AccountName) ||
                                        (option?.Name !== undefined && option?.Name !== null && option.Name === selectedAcc?.Name)
                                    );
                                    const optionBalance = getOptionBalance(option);
                                    return (
                                        <li
                                            key={index}
                                            data-index={index}
                                            tabIndex={0}
                                            onKeyDown={(event) => {
                                                if (event.key === 'Enter') {
                                                    event.preventDefault();
                                                    if (option?.Name === t('no_linked_acccounts')) {
                                                        return;
                                                    }
                                                    const element = event.currentTarget;
                                                    element.style.opacity = 0.8;
                                                    handleOptionSelect(option, index);
                                                    setTimeout(() => { element.style.opacity = 1; }, 200);
                                                }
                                            }}
                                            onClick={() => {
                                                if (option?.Name === t('no_linked_acccounts')) {
                                                    return;
                                                }
                                                handleOptionSelect(option, index)
                                            }}
                                            className={`group py-4 px-2 sm:px-4 cursor-pointer focus:outline-none ${props?.boxed ? 'hover:bg-[#2965FB]' : 'hover:bg-[var(--selected-hover-bg)]'} ${isSelectedOption || (props?.boxed && index === selectedIndex) ? 'bg-[#2965FB]' : ''} text-[var(--text-clr-transactions)] hover:text-[var(--custom-dropdown-hover-text)] ${!props?.boxed && index === selectedIndex ? 'bg-[var(--selected-hover-bg)]' : ''} ${index === selectedIndex ? 'dropdown-selected' : ''}`}
                                        >
                                            <div
                                                className={`flex items-center gap-3 lg:text-[16px] md:text-[15px] sm:text-[13px] text-[14px] font-hanken-grotesk font-[500] leading-[26px] ${props?.boxed ? 'group-hover:text-white' : ''} ${isSelectedOption || (props?.boxed && index === selectedIndex) ? 'text-white' : ''}`}
                                            >
                                                {props?.boxed && option?.Name !== t('no_linked_acccounts') &&
                                                    <span className='relative w-4 h-4 shrink-0'>
                                                        <img src={getAccountLogo(option)} alt="" className={`w-4 h-4 object-contain ${getAccountLogo(option) === klogoGreen ? `group-hover:brightness-0 group-hover:invert ${isSelectedOption || index === selectedIndex ? 'brightness-0 invert' : ''}` : ''}`} />
                                                    </span>
                                                }
                                                <span className={`flex-1 whitespace-nowrap group-hover:text-white ${isSelectedOption || index === selectedIndex ? 'text-white' : kudzuPlusTrue ? 'text-white' : 'text-[#262B3A]'}`}>
                                                    {option.Name || option.AccountName?.slice(0, -6) || option.DisplayText || ''}
                                                    <span className="font-[700] font-hanken-grotesk 
 md:text-[12px] sm:text-[9px] text-[12px]">{option.AccountName?.slice(-6)}</span>
                                                </span>
                                                {props?.boxed && optionBalance !== null &&
                                                    <span className={`font-hanken-grotesk font-[600] lg:text-[16px] md:text-[14px] sm:text-[12px] text-[14px] whitespace-nowrap group-hover:text-white ${isSelectedOption || index === selectedIndex ? 'text-white' : 'text-[#22874E]'}`}>{`$${optionBalance.toFixed(2)} Available`}</span>
                                                }
                                                {(isSelectedOption || (props?.boxed && index === selectedIndex)) &&
                                                    <svg className='w-4 h-4 shrink-0 ml-1' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
                                                        <path d='M20 6L9 17L4 12' stroke='#FFFFFF' strokeWidth='2.5' strokeLinecap='round' strokeLinejoin='round' />
                                                                            </svg>
                                                                            }
                                                                        </div>
                                                                    </li>
                                                                );
                                })}
                            </ul>
                            {props?.actionText &&
                                <button
                                    type='button'
                                    className={`w-full py-4 px-2 sm:px-4 text-left font-hanken-grotesk font-[600] ${kudzuPlusTrue ? 'text-white' : 'text-[#2965FB]'} text-[14px] sm:text-[13px] md:text-[15px] lg:text-[16px]`}
                                    onClick={handleActionClick}
                                >
                                    + {props?.actionText}
                                </button>
                            }
                        </div>
                    )}
                    {props?.error &&
                        <div className='my-2 w-full'>
                            {kudzuPlusTrue ? displayKudzuplusErrorMessage(props?.error) : displayErrorMessage(props?.error)}
                        </div>
                    }
                </div>
) : (
                    <div className=' flex flex-col w-full'>
                        <p className='font-hanken-grotesk text-[var(--primary-text-cards)] 
      uppercase text-[13px] sm:text-[9px] lg:text-[13px]
       font-[600] tracking-[2px] pb-5 md:pb-6'>{props?.title?.toLocaleUpperCase() || ''}</p>

                        <div className={`w-full ${isOpen && 'outline-none'}`} onClick={() => { if (props?.disabled) { if (props.disabled === 'not_disabled') { toggleDropdown(); } } else { toggleDropdown(); } }}
                            tabIndex={0}
                            onKeyDown={(event) => {
                                const isChrome = /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor) && !/Edg|Firefox|Safari|OPR|MSIE|Trident/.test(navigator.userAgent);
                                if (event.key === "Enter") {
                                    event.preventDefault();
                                    if (props?.disabled) { if (props.disabled === 'not_disabled') { toggleDropdown(); } } else { toggleDropdown(); }
                                    if ((selectedIndex > '-1') && (selectedIndex !== null) && (!isChrome) && (isOpen)) { handleOptionSelect(props.options[selectedIndex], selectedIndex); }
                                } else if (!isChrome && event.key === 'ArrowDown') {
                                    if (isOpen) { event.preventDefault(); }
                                    setSelectedIndex((prevIndex) => (prevIndex > '-1' && prevIndex !== null && prevIndex !== undefined) ? prevIndex < props.options.length - 1 ? (prevIndex > '-1' && prevIndex !== null) ? (prevIndex + 1) : 0 : prevIndex : 0);
                                } else if (!isChrome && event.key === 'ArrowUp') {
                                    if (isOpen) { event.preventDefault(); }
                                    setSelectedIndex((prevIndex) => (prevIndex > 0 ? prevIndex - 1 : prevIndex));
                                }
                                else if ((!isChrome) && (event.key === 'Tab') && isOpen) {

                                    if (event.shiftKey) {
                                        if (selectedIndex > 0) {
                                            event.preventDefault();
                                            setSelectedIndex((prevIndex) => (prevIndex > 0 ? prevIndex - 1 : prevIndex));
                                        } else if (selectedIndex === 0) { toggleDropdown(); setSelectedIndex('-1') }
                                    } else if (selectedIndex < props.options.length - 1 || Number(selectedIndex) === -1 || selectedIndex === null || selectedIndex === undefined) {
                                        event.preventDefault();
                                        setSelectedIndex((prevIndex) => (prevIndex > '-1' && prevIndex !== null && prevIndex !== undefined) ? prevIndex < props.options.length - 1 ? (prevIndex > '-1' && prevIndex !== null) ? (prevIndex + 1) : 0 : prevIndex : 0);
                                    } else if (selectedIndex >= props.options.length - 1) {
                                        event.preventDefault();
                                    }
                                }
                            }
                            }
                        >
                            <div className={`flex justify-between flex-row w-full ${isOpen && 'outline-none'}`}>
                                <div className={`sm:flex block justify-between flex-row items-center mb-4 w-full 'outline-none'`}>
                                    <p contentEditable={false} className={`font-[500] text-[var(--text-clr-transactions)] font-hanken-grotesk lg:text-[16px]
 md:text-[15px] sm:text-[13px] text-[14px] cursor-none ${isOpen && 'outline-none'}`}>
                                        {props?.selectedAccountType?.Name || props?.selectedAccountType?.AccountName?.slice(0, -6) || props?.selectedAccountType?.DisplayText || props?.selectedFrequency || 'Select'}
                                        <span className="font-[700] font-hanken-grotesk 
 md:text-[12px] sm:text-[9px] text-[12px]">{props?.selectedAccountType?.AccountName?.slice(-6)}</span>
                                    </p>
                                    {isInternalAccount && (
    <p
        className={`${props?.balanceFontColor ? props.balanceFontColor : 'text-[var(--text-clr-transactions)]'} mt-4 sm:mt-0 font-hanken-grotesk font-[500] text-[16px] leading-[24px] md:leading-[26px] sm:text-[12px] md:text-[14px] lg:text-[16px] sm:text-right cursor-none ${isOpen ? 'outline-none' : ''}`}
    >
        {t('amount_available', { amount: accountBalance })}
    </p>
                                    )}
                                </div>
                                <div>
                                    {!props?.hideArrow &&
                                        <img
                                            src={appThemeData.dropDownIcon}
                                            alt="dropdown-icon"
                                            className={`w-3 h-3 mr-2 ml-10 cursor-pointer outline-none}`}
                                        />
                                    }

                                </div>
                            </div>

                            <hr tabindex="-2" className={` h-[2px] ${props?.hrbg ? props?.hrbg : 'bg-[var(--content-border)] opacity-[50%]'} border-0 rounded`} />
                        </div>
                        {isOpen && (
                            <div className={`bg-[var(--custom-dropdown-bg)] relative z-10 ${props?.isScroll ? 'max-h-[13rem] overflow-y-auto' : 'sm:max-h-[30rem] max-h-[20rem] overflow-y-auto'}`}>
                                <ul
                                    onBlur={() => setSelectedIndex(-1)} // Reset selection when the dropdown loses focus
                                    onKeyDown={handleKeyDown}
                                    ref={dropdownRef

                                    }>
                                    {props?.options?.map((option, index) => (
                                        <div
                                            onKeyDown={(event) => {
                                                if (event.key === "Enter") {
                                                    event.preventDefault();
                                                    if (option?.Name === t('no_linked_acccounts')) {
                                                        return;
                                                    }
                                                    event.target.style.opacity = 0.8;
                                                    handleOptionSelect(option, index);
                                                    setTimeout(() => { event.target.style.opacity = 1; }, 200);
                                                }
                                            }}
                                            className={`py-4 sm:pl-4 pl-2 hover:bg-[var(--selected-hover-bg)] text-[var(--text-clr-transactions)] hover:text-[var(--custom-dropdown-hover-text)]   ${index === selectedIndex ? 'bg-[var(--selected-hover-bg)]' : ''}`}
                                            key={index}
                                        >
                                            <li
                                                className={` lg:text-[16px] md:text-[15px] sm:text-[13px] text-[14px] cursor-pointer focus:outline-none  font-hanken-grotesk font-[500] leading-[26px] ${index === selectedIndex ? 'dropdown-selected' : ''}`}
                                                data-index={index}
                                                tabIndex={0}
                                                onKeyDown={(event) => {
                                                    if (event.key === 'Enter') {
                                                        event.preventDefault();
                                                        if (option?.Name === t('no_linked_acccounts')) {
                                                            return;
                                                        }
                                                        event.target.style.opacity = 0.8;
                                                        handleOptionSelect(option, index);
                                                        setTimeout(() => {
                                                            event.target.style.opacity = 1;
                                                        }, 200);
                                                    }
                                                }}
                                                onClick={() => {
                                                    if (option?.Name === t('no_linked_acccounts')) {
                                                        return;
                                                    }
                                                    handleOptionSelect(option, index)
                                                }}
                                            >
                                                {option.Name || option.AccountName?.slice(0, -6) || option.DisplayText || ''}
                                                <span className="font-[700] font-hanken-grotesk 
 md:text-[12px] sm:text-[9px] text-[12px]">{option.AccountName?.slice(-6)}</span>
                                            </li>
                                        </div>
                                    ))}
                                </ul>
                            </div>
                        )}
                        {props?.error &&
                            <div className='my-2 w-full'>
                                {kudzuPlusTrue ? displayKudzuplusErrorMessage(props?.error) : displayErrorMessage(props?.error)}
                            </div>
                        }
                    </div> 
)}
</>

        
    );
};

export default CustomDropdown;
